// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SplashScreen_wrapper__3D9td","logoWrapper":"SplashScreen_logoWrapper__1qp9U","highlightAnim":"SplashScreen_highlightAnim__3Z8le","logo":"SplashScreen_logo__12q3D"};